import { render } from "./TeamActiveIcon.vue?vue&type=template&id=1d16144c"
import script from "./TeamActiveIcon.vue?vue&type=script&lang=js"
export * from "./TeamActiveIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__